<template>
    <div>
        <rkm-row>
            <rkm-col cols="3">
                <rkm-form-time-picker
                    label="Saída"
                    v-model="model.escala.horaSaida"
                    :disabled="disabled"
                    :validations="validations.horaSaida"
                />
            </rkm-col>

            <rkm-col cols="4">
                <rkm-form-input
                    label="Número de atendimentos"
                    number
                    v-model="model.escala.quantidadeAtendimentos"
                    :validations="validations.quantidadeAtendimentos"
                    :disabled="disabled"
                />
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
// Mixins.
import { data } from '@/mixins'

export default {
    mixins: [ data ],
    props:{
        form: { type: Object, required: true },
        model: { type: Object, required: true },
        disabled: { type: Boolean, default: false },
    },
    computed: {
        validations() {

            return {
                horaSaida: {
                    required: true,
                    plantao_date_fim_greater_than24_hours_from_inicio: {
                        periodo: {
                            start: this.model.escala.periodo.start,
                            end: this.model.escala.periodo.end,
                        },
                        horaEntrada: this.model.escala.horaEntrada
                    },
                    plantao_date_fim_greater_than_inicio: {
                        periodo: {
                            start: this.model.escala.periodo.start,
                            end: this.model.escala.periodo.end,
                        },
                        horaEntrada: this.model.escala.horaEntrada
                    }
                },
                quantidadeAtendimentos: { required: true, max: 8 }
            }
        }
    },
}
</script>